import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Row, Col } from "antd";
import { BASE_INBOX_COLS } from "constants/table-columns";
import { fetchBucketCases } from "store/actions";
import { bindActionCreators } from "redux";
import { Table } from "components";
import { Map, List } from "immutable";
import { STATE_STATUS } from "constants/index";
class DistributorOnBoarding extends React.Component {
    state = {
        data: [],
        currentPage: 1,
        columns: []
    };

    // columns = [];
    pageSize = 10;

    componentDidMount() {
        const { stage, casesStatus, fetchBucketCases } = this.props;
        if(stage && casesStatus === STATE_STATUS.UNFETCHED) {
            fetchBucketCases(
                JSON.stringify([stage.id]),
                "all",
                this.state.currentPage,
                this.pageSize,
                stage.stage_name,
                "INBOX"
            );
        }
        if(stage && !this.state.columns || !this.state.columns.size) {
            this.setState({
                columns:  stage.columns.map(_ => Object.keys(_)[0])
            });
        }
    }

    componentDidUpdate() {
        const { stage, casesStatus, fetchBucketCases } = this.props;
        if(stage && casesStatus === STATE_STATUS.UNFETCHED) {
            fetchBucketCases(
                JSON.stringify([stage.id]),
                "all",
                this.state.currentPage,
                this.pageSize,
                stage.stage_name,
                "INBOX"
            );
        }
        if(stage && !this.state.columns || !this.state.columns.size) {
            this.setState({
                columns:  stage.columns.map(_ => Object.keys(_)[0])
            });
        }
    }
    render() {
        const { casesStatus, cases } = this.props;
        if(casesStatus !== STATE_STATUS.FETCHED) {
            return "FETCHING";
        }
        let selectedCols = BASE_INBOX_COLS.filter((_, k) => this.state.columns.includes(k));
        return (
            <Row>
                <Col span={24} className={"h-100 p-5"}>
                    <Table 
                        title={"MPA Cases"}
                        checkedColumns={this.state.columns && this.state.columns.size && this.state.columns.toArray() || []}
                        columns={selectedCols || new Map({})}
                        data={cases.get(this.state.currentPage) || new List([])}
                    />
                </Col>
            </Row>
        );
    }
}

DistributorOnBoarding.propTypes = {
    fetchBucketCases: PropTypes.func,
    casesStatus: PropTypes.string,
    cases: PropTypes.object,
    stage: PropTypes.object
};

const mapStateToProps = state => ({
    stage: state.stagePermissions.get("data").find(_ => _.stage_name === "DPA"),
    casesStatus: state.cases.getIn(["INBOX", "DPA", "status"]),
    cases: state.cases.getIn(["INBOX", "DPA", "data"]),
});

const mapDispatchToProps= dispatch =>
    bindActionCreators(
        {
            fetchBucketCases
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(DistributorOnBoarding);